"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));

var Select = function (_super) {
  __extends(Select, _super);

  function Select(props) {
    var _this = _super.call(this, props) || this;

    _this.handleExpandClick = function () {
      _this.setState({
        isExpanded: !_this.state.isExpanded
      });
    };

    _this.handleOutsideClick = function () {
      _this.setState({
        isExpanded: false
      });
    };

    _this.handleSelectClick = function (value) {
      var options = _this.props.options;
      var newOption = options.find(function (_a) {
        var v = _a.value;
        return v === value;
      });

      _this.setState({
        isExpanded: false,
        selectedOption: newOption
      });
    };

    var options = props.options,
        defaultValue = props.defaultValue;
    _this.state = {
      isExpanded: false,
      selectedOption: options.find(function (_a) {
        var value = _a.value;
        return defaultValue === value;
      })
    };
    return _this;
  }

  Select.prototype.componentDidUpdate = function (prevProps, prevState) {
    if (prevState.isExpanded !== this.state.isExpanded) {
      var onExpand = this.props.onExpand;
      onExpand && onExpand(this.state.isExpanded);
    }

    if (this.state.selectedOption && (prevState.selectedOption && prevState.selectedOption.value) !== this.state.selectedOption.value) {
      var onChange = this.props.onChange;
      onChange && onChange(this.state.selectedOption);
    }
  };

  Select.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        _b = _a.className,
        className = _b === void 0 ? "" : _b,
        options = _a.options,
        placeholder = _a.placeholder,
        isDisabled = _a.isDisabled;
    var _c = this.state,
        isExpanded = _c.isExpanded,
        selectedOption = _c.selectedOption;
    var expandButtonClass = isExpanded ? "select-menu__button--active" : "";
    var expanListClass = isExpanded ? "select-menu__list--active" : "";
    var disabledColorClass = isDisabled ? "icon--black-3" : "";
    return react_1["default"].createElement("div", {
      className: "select-menu " + className
    }, react_1["default"].createElement(react_outside_click_handler_1["default"], {
      onOutsideClick: this.handleOutsideClick,
      disabled: !isExpanded
    }, react_1["default"].createElement("button", {
      className: "select-menu__button " + expandButtonClass + " " + disabledColorClass,
      onClick: this.handleExpandClick,
      disabled: isDisabled
    }, react_1["default"].createElement("span", {
      className: "select-menu__button-label"
    }, selectedOption && selectedOption.label || placeholder), react_1["default"].createElement("span", {
      className: "select-menu__icon " + disabledColorClass
    })), react_1["default"].createElement("ul", {
      className: "select-menu__list " + expanListClass + " " + disabledColorClass,
      style: {
        top: "-24px"
      }
    }, options && options.map(function (_a, i) {
      var value = _a.value,
          label = _a.label,
          divider = _a.divider;
      return divider ? react_1["default"].createElement("div", {
        className: "select-menu__divider",
        key: "select-option--" + i
      }, divider === true ? react_1["default"].createElement("span", {
        className: "select-menu__divider-line"
      }) : react_1["default"].createElement("span", {
        className: "select-menu__divider-label"
      }, divider)) : react_1["default"].createElement("li", {
        className: "select-menu__list-item " + (selectedOption && selectedOption.value === value ? "select-menu__list-item--active" : ""),
        onClick: function onClick() {
          return _this.handleSelectClick(value);
        },
        key: "select-option--" + i
      }, react_1["default"].createElement("span", {
        className: "select-menu__list-item-icon"
      }), react_1["default"].createElement("span", {
        className: "select-menu__list-item-text"
      }, label));
    }))));
  };

  return Select;
}(react_1["default"].Component);

exports["default"] = Select;